window.chartVerbindlichkeiten = {
	data: {
		kategorie: [],
	},

	showLoading() {
		this.chart.showLoading()
	},

	hideLoading() {
		this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.Chart("chart_verbindlichkeiten", {
			chart: {
				type: "pie",
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				headerFormat: "",
				pointFormatter: function () {
					return `${this.name}<br/><b>${Highcharts.numberFormat(this.percentage, 0)}%</b>`
				},
				style: {
					fontSize: chartFontSizeMittel,
					textAlign: "center",
				},
			},

			plotOptions: {
				series: {
					animation: {
						duration: 1200,
						easing: "easeInOut",
					},
					animationLimit: Infinity,
				},
			},

			series: this.seriesStruktur(),
		})
	},

	update() {
		if (!this.chart) return

		// this.chart.showLoading()

		const seriesArrays = [this.seriesStruktur(), this.seriesKategorie()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.redraw({ duration: 1200 })
		this.chart.hideLoading()
	},

	updateSeriesData(seriesData) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		this.chart.redraw({ duration: 1200 })

		this.updateLegend()
	},

	updateLegend() {
		const legend = document.querySelector(".chartlegende")

		legend.innerHTML = ""

		var types = this.chart.series[0].data.reduce((arr, { origin, legendColor }, i) => {
			const obj = arr.find((o) => o.origin === origin)
			if (obj) obj.indexes.push(i)
			else arr.push({ origin, legendColor, indexes: [i] })
			return arr
		}, [])

		types.forEach((type) => {
			if (type.origin) {
				html = '<label class="serieLabel" data-name="' + type.origin + '"><span class="symbol" style="background-color:' + type.legendColor + '"></span><span class="name">' + type.origin + "</span></label>"
				legend.insertAdjacentHTML("beforeend", html)
			}
		})

		document.addEventListener("click", function (e) {
			if (e.target.closest(".chartlegende .serieLabel")) {
				const serieLabel = e.target.closest(".chartlegende .serieLabel")
				const indexes = types.find((t) => t.origin === serieLabel.dataset.name).indexes

				serieLabel.classList.toggle("hide")
				indexes.forEach((inx, i) => {
					const point = chartVerbindlichkeiten.chart.series[0].data[inx]
					point.setVisible(!point.visible, i === indexes.length - 1)
				})
			}
		})
	},

	seriesStruktur() {
		const data = []
		const kreditgruppen = document.querySelectorAll("[data-kreditgruppe-bezeichnung]")

		kreditgruppen.forEach((kreditgruppe) => {
			const farbe = getGradientColor(kreditgruppe.dataset.farbe)
			const bezeichnung = kreditgruppe.dataset.kreditgruppeBezeichnung
			const divKredits = kreditgruppe.querySelector("details")
			const kredits = Array.from(kreditgruppe.querySelectorAll("[data-bezeichnung]"))

			if (divKredits.open) {
				// Jeden Kredit einzeln anzeigen
				kredits.forEach((kredit) => {
					const bezeichnung = kredit.dataset.bezeichnung
					const betrag = parseInt(kredit.dataset.betrag)

					data.push({
						name: bezeichnung,
						color: farbe,
						y: Math.abs(betrag),
					})
				})
			} else {
				// Summe der Kredite pro Vermögenswerte ermitteln
				const betrag = kredits.reduce((summe, kredit) => summe + parseInt(kredit.dataset.betrag), 0)

				data.push({
					name: bezeichnung,
					color: farbe,
					y: Math.abs(betrag),
				})
			}
		})

		return (series = [
			{
				id: "kredite",
				data: data,
			},
		])
	},

	seriesKategorie() {
		const data = []
		const kreditgruppen = document.querySelectorAll("[data-kreditgruppe-bezeichnung]")

		kreditgruppen.forEach((kreditgruppe) => {
			const kredits = Array.from(kreditgruppe.querySelectorAll("[data-bezeichnung]"))

			// Jeden Kredit einzeln anzeigen
			kredits.forEach((kredit) => {
				const bezeichnung = kredit.dataset.bezeichnung
				const betrag = parseInt(kredit.dataset.betrag)
				const farbe = kredit.dataset.steuerwirksam === "true" ? farbeKreditSteuerwirksam : farbeKreditNichtSteuerwirksam
				const origin = kredit.dataset.steuerwirksam === "true" ? "Steuerwirksam" : "Nicht steuerwirksam"

				data.push({
					name: bezeichnung,
					color: getGradientColor(farbe),
					legendColor: farbe,
					origin: origin,
					y: Math.abs(betrag),
				})
			})
		})

		return (series = [
			{
				id: "steuerwirksamkeit",
				data: data,
			},
		])
	},
}
